import * as Yup from 'yup';
import { IValidation } from '../../models/components/validation-props';
import { DefaultValidation } from './main-validations';

export function getValidation(props?: IValidation) {
    
    const defaultValidation = new DefaultValidation(props);

    if(props && props.isProjectSubActivity) {
        return Yup.object().shape({ 
            name: defaultValidation.GetName()
        });
    }    
    
    if(props && props.isExamQuestion)
    {
        return Yup.object().shape({ 
            defaultValuesFormik: defaultValidation.SetDefaultValues(),
            selectActivity: defaultValidation.GetSelectActivity(),
            masterCourseName: defaultValidation.GetMasterCourseName(),
            questionText: defaultValidation.GetQuestionText(),
            questionType: defaultValidation.GetNotEditable()
        });

    }
    return Yup.object().shape({
        defaultValuesFormik: defaultValidation.SetDefaultValues(),
        selectActivity: defaultValidation.GetSelectActivity(),
        masterCourseName: defaultValidation.GetMasterCourseName(),
        questionText: defaultValidation.GetQuestionText(),
    });
}
